<template>
    <div class="chose-shipping-options">
        <div class="field field--shipping-method">
            <div class="title is-4 has-text-grey">
                {{ $t('orderDetails.labels.shippingMethod') }}
            </div>
            <div class="control" :class="{ 'is-disabled': !isEditable }">
                <label
                    class="radio my-3"
                    v-for="option in shippingMethods"
                    :key="`shipping-method-option__${option._id}`"
                >
                    <input
                        type="radio"
                        :id="option._id"
                        :value="option.shippingMethodId"
                        :disabled="!isEditable"
                        name="shipping-method"
                        v-model="shippingMethod"
                        :is-default="true"
                    />
                    <div class="shipping-method__info">
                        <div class="shipping-method__label">
                            {{ option.shippingMethod }} -
                            <strong class="has-text-primary-dark">{{
                                (isBusinessCustomer
                                    ? option.pricing.netPrice
                                    : option.pricing.totalPrice) | currency
                            }}</strong>
                        </div>
                        <div class="shipping-method__time">
                            {{ $t('orderDetails.labels.productionTime') }}
                            <strong>{{
                                $tc(
                                    'orderDetails.businessDays',
                                    productionTimeDays
                                )
                            }}</strong>
                        </div>
                        <div class="shipping-method__time">
                            + {{ $t('orderDetails.labels.deliveryTime') }}
                            <strong>{{
                                $tc(
                                    'orderDetails.regularDays',
                                    option.shippingTimeDays
                                )
                            }}</strong>
                        </div>
                    </div>
                </label>
            </div>
        </div>
        <template v-if="isEditable">
            <div class="title is-4 has-text-grey mt-6">
                {{ $t('orderDetails.labels.deliveryAndProductionTime') }}
            </div>
            <div class="subtitle is-5">
                <strong class="has-text-dark">{{
                    $tc(
                        'orderDetails.businessDays',
                        productionTimeDays +
                            chosenShippingMethod.shippingTimeDays
                    )
                }}</strong>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { MATERIAL_MAPPING } from '../../../store/constants/material-mapping';
import { calculateTaxes } from '../../../utilities/tax-calculations';

export default {
    name: 'ChooseShippingOption',
    data() {
        return {
            shippingMethod: null,
        };
    },
    props: {
        isEditable: {
            required: false,
            default: true,
        },
    },
    computed: {
        ...mapGetters([
            'allCartItems',
            'paymentDetails',
            'taxRate',
            'isBusinessCustomer',
            'shippingCountryById',
            'orderTrackingInfo',
            'discountApplied',
            'discount',
        ]),
        shippingMethods() {
            return this.$store.getters
                .shippingCountryById(
                    this.paymentDetails.shippingAddress.countryId
                )
                .shippingMethods.map((shippingMethod) => {
                    let price = shippingMethod.priceCents;
                    if (
                        shippingMethod.shippingMethod === 'Standard-Versand' &&
                        this.discountApplied &&
                        this.discount.rules.freeShipping
                    ) {
                        price = 0;
                    }
                    return {
                        ...shippingMethod,
                        pricing: calculateTaxes(price, this.taxRate),
                    };
                });
        },
        chosenShippingMethod() {
            let shippingMethod;
            if (
                this.orderTrackingInfo.shippingMethod &&
                this.orderTrackingInfo.shippingCosts
            ) {
                shippingMethod = {
                    ...this.orderTrackingInfo.shippingMethod,
                    pricing: this.orderTrackingInfo.shippingCosts,
                    priceCents:
                        this.orderTrackingInfo.shippingCosts.calculatedTaxes
                            .price * 100,
                };
            } else {
                shippingMethod = this.$store.getters
                    .shippingCountryById(
                        this.paymentDetails.shippingAddress.countryId
                    )
                    .shippingMethods.find(
                        (method) =>
                            method.shippingMethodId ===
                            this.paymentDetails.shippingMethodId
                    );
            }
            let price =
                this.discountApplied && this.discount.rules.freeShipping
                    ? 0
                    : shippingMethod.priceCents;
            return {
                ...shippingMethod,
                pricing: calculateTaxes(price, this.taxRate),
            };
        },
        productionTimeDays() {
            let productionTimeDays = 0;
            Object.values(this.allCartItems).forEach((cartItem) => {
                if (cartItem.productionTime > productionTimeDays) {
                    productionTimeDays = cartItem.productionTime;
                }
            });

            return productionTimeDays;
        },
    },
    watch: {
        shippingMethod(value) {
            this.$store.dispatch('updatePaymentDetails', {
                paymentDetails: {
                    ...this.paymentDetails,
                    shippingMethodId: value,
                },
            });
        },
    },
    async created() {
        await this.$store.dispatch('fetchShippingCountries');

        this.shippingMethod = this.shippingMethods[0].shippingMethodId;
        if (this.orderTrackingInfo.shippingMethod) {
            this.shippingMethod = this.orderTrackingInfo.shippingMethod.id;
        }
    },
};
</script>
<style lang="scss">
.chose-shipping-options {
    .control.is-disabled {
        opacity: 0.5;
    }
}
</style>
